/**
 * OAuth callback params can be very long and may contain `+`.
 * URLSearchParams can normalize `+` to spaces, which can corrupt auth codes.
 * This helper parses from the raw query/hash string and preserves `+` as-is.
 */
const decodeParamSafely = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const stripPrefix = (value: string): string => {
  if (value.startsWith('?') || value.startsWith('#')) return value.slice(1);
  return value;
};

export const getRawUrlParam = (
  rawSearchOrHash: string,
  paramName: string
): string | null => {
  const source = stripPrefix(rawSearchOrHash || '');
  if (!source) return null;

  const encodedParamName = encodeURIComponent(paramName);
  const pattern = new RegExp(`(?:^|&)${encodedParamName}=([^&]*)`);
  const match = source.match(pattern);
  if (!match) return null;

  return decodeParamSafely(match[1]);
};

export const getOAuthParamFromLocation = (paramName: string): string | null => {
  if (typeof window === 'undefined') return null;

  const fromSearch = getRawUrlParam(window.location.search, paramName);
  if (fromSearch != null) return fromSearch;

  return getRawUrlParam(window.location.hash, paramName);
};
